/* eslint-disable max-lines */
import { bool, func, object, string } from 'prop-types'
import styled from 'styled-components'
import React, { useEffect, useState } from 'react'
import Button from '@taglivros/oef_componentes/build/components/button'
import Input from '@taglivros/oef_componentes/build/components/input'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { themeV2 as theme } from '@taglivros/tag-components'
import { RECAPTCHA_KEY } from '../../utils/recaptcha'

import { BANDEIRAS_IMAGES } from '../../constants'
import {
  NUMERO_CARTAO_INVALIDO,
  REQUIRED_MESSAGE,
  CVV_INVALIDO,
  FORMATO_DATA_INVALIDO,
  DATA_INVALIDA,
  TEXTO_HELPER_CVV
} from './constantsCartaoCredito'

import { formartNumeroCartao, formatData, formatNomeCartao, formatCVV } from '../../utils/formatter/formatter'
import { empty, sanitizeValue, isEmptyObject, isDataVencimentoValida, handleKeyPressNumber } from '../../utils/helpers/helpers'
import { useCartaoCredito } from '../../contexts/CartaoCreditoContext'
import InlineLoader from '../InlineLoader/InlineLoader'
import { useGlobal } from '../../contexts/GlobalContext'

const LoadingWrapper = styled.div`
  align-items: center;
  background: rgba(255,255,255,0.7);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 2;

  > div {
    margin: 0;
  }
`

const CartaoCreditoWrapper = styled.div`
  .row--input {
    & > div {
      z-index: 1;
    }

    @media (min-width: ${StyleGuide.mediaQuery.mobile}) {
      margin-bottom: 10px;
    }

    .input__mensagem--erro {
      margin-top: 2px;
    }
  }

  .row--double {
    display: flex;
    flex-wrap: no-wrap;
    justify-content: space-between;

    @media (max-width: 520px) {
      flex-wrap: wrap;
    }
  }

  .input--margin-cvv {
    position: relative;

    @media (min-width: ${StyleGuide.mediaQuery.mobile}) {
      margin-left: 16px;
    }

    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      width: 100%;

      .icone--tooltip:hover + p {
        transform: translate(10%,-140%);
      }
    }


    .mensagem--tooltip {
      @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
        &::after {
          left: 90%;
        }
      }
    }
  }

  .lista--bandeira__cartao {
    display: flex;
    margin-bottom: 25px;

    li {
      margin-right: 5px;
    }
  }
`

const BotaoWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;

  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    flex-direction: column;
  }

  button {
    margin-right: 10px;

    &:last-of-type {
      margin-right: 0px;
    }

    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      margin-right: 0px;
      margin-top: 10px;

      &:first-of-type {
        margin: 0px;
      }
    }
  }
`

const CaptchaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border: solid 1px ${theme.palette[ 'TAG1-100' ]};
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 20px;
  align-items: center;
`

const CartaoCreditoForm = ( { loading, onCancelar, onConfirmar, tema } ) => {
  const [ erros, setErros ] = useState( {} )
  const [ state, setState ] = useState( {} )
  const [ sucesso, setSucesso ] = useState( {} )
  const [ camposObrigatoriosPreenchidos, setCamposObrigatoriosPreenchidos ] = useState( false )
  const camposObrigatorios = [ 'numero', 'cvv', 'nome', 'vencimento' ]
  const { cartaoValidado, errosCadastro, errosCartao, validaCartao, getBandeira, 'bandeira': bandeiraCartao } = useCartaoCredito()
  const { captcha, setCaptcha } = useGlobal()

  const handleKeyPress = ( event ) => {
    handleKeyPressNumber( event )
  }

  useEffect( () => {
    if ( !isEmptyObject( errosCartao ) ) {
      setErros( {
        ...erros,
        ...errosCartao
      } )
      Object.entries( errosCartao ).forEach( erro => {
        const [ campo, descricao ] = erro
        if ( descricao !== '' ) {
          setSucesso( { ...sucesso, [ campo ]: false } )
        }
      } )
    }
  }, [ errosCartao ] )

  useEffect( () => {
    if ( errosCadastro && errosCadastro.length ) {
      // eslint-disable-next-line array-callback-return
      errosCadastro.map( item => {
        setErros( {
          ...erros,
          [ item.source ]: item.message
        } )
      } )
    }
  }, [ errosCadastro ] )

  useEffect( () => {
    if ( !isEmptyObject( cartaoValidado ) && !onCancelar ) {
      onConfirmar( cartaoValidado )
    }
  }, [ cartaoValidado, onCancelar, onConfirmar ] )

  useEffect( () => {
    if ( !isEmptyObject( state ) ) {
      const hasPreenchimento = camposObrigatorios.reduce( ( acumulador, campoObrigatorio ) => {
        return !empty( state[ campoObrigatorio ] ) && empty( erros[ campoObrigatorio ] ) && acumulador
      }, true )

      if ( isEmptyObject( erros ) ) {
        setCamposObrigatoriosPreenchidos( hasPreenchimento )
      } else {
        // eslint-disable-next-line array-callback-return
        Object.keys( erros ).map( item => {
          setSucesso( {
            ...sucesso,
            [ item ]: empty( erros[ item ] ) && !empty( state[ item ] )
          } )
        } )

        setCamposObrigatoriosPreenchidos( false )
      }
    }
  }, [ erros, state, captcha ] )

  useEffect( () => {
    if ( camposObrigatoriosPreenchidos ) {
      validaCartao( state )
    }
  }, [ camposObrigatoriosPreenchidos ] )

  useEffect( () => {
    renderRecaptcha()
  }, [] )

  const validate = ( event, isOnSubmit=false ) => {
    const { name, value } = event.target
    const regrasValidacoes = {
      '1': {
        'erro': {
          ...camposObrigatorios.reduce( ( acumulador, obrigatorio ) => {
            if ( empty( state[ obrigatorio ] ) ) {
              return {
                ...acumulador,
                [ obrigatorio ]: REQUIRED_MESSAGE
              }
            }
            return null
          }, {} )
        },
        'verificar': () => !camposObrigatoriosPreenchidos && isOnSubmit
      },
      '2': {
        'erro': {
          [ name ]: REQUIRED_MESSAGE
        },
        'verificar': () => value === '' && !isOnSubmit
      },
      '3': {
        'erro': {
          'numero': NUMERO_CARTAO_INVALIDO
        },
        'verificar': () => name === 'numero' && state.numero.length <= 17
      },
      '4': {
        'erro': {
          'cvv': CVV_INVALIDO
        },
        'verificar': () => name === 'cvv' && state.cvv.length < 3
      },
      '5': {
        'erro': {
          'vencimento': FORMATO_DATA_INVALIDO
        },
        'verificar': () => name === 'vencimento' && state.vencimento.length < 4
      },
      '6': {
        'erro': {
          'vencimento': DATA_INVALIDA
        },
        'verificar': () => name === 'vencimento' && state.vencimento && !isDataVencimentoValida( value )
      },
      '7': {
        'erro': {
          [ name ]: REQUIRED_MESSAGE
        },
        'verificar': () => value === '' && !isOnSubmit
      }
    }

    const errosCampos = Object.values( regrasValidacoes )
      .find( ( { verificar, erro } ) => verificar() && erro )

    let validacaoErros = {
      ...erros
    }

    if ( errosCampos ) {
      validacaoErros = {
        ...erros,
        ...errosCampos.erro
      }
    }

    setErros( validacaoErros )

    setSucesso( {
      ...sucesso,
      [ name ]: empty( validacaoErros[ name ] ) && !empty( state[ name ] )
    } )
  }

  const handleChange = event => {
    setCamposObrigatoriosPreenchidos( false )
    const { name, value } = event.target
    let valor = null
    setErros( {
      ...erros,
      [ name ]: null
    } )

    setSucesso( {
      ...sucesso,
      [ name ]: null
    } )

    if ( name === 'numero' ) {
      valor = formartNumeroCartao( sanitizeValue( value ) )
    } else if ( name === 'vencimento' ) {
      valor = formatData( sanitizeValue( value ) )
    } else if ( name === 'nome' ) {
      valor = formatNomeCartao( value )
    } else if ( name === 'cvv' ) {
      valor = formatCVV( value )
    }
    if ( name === 'numero' && valor.length === 19 ) {
      const cartao = {
        'numero': `${valor}`,
        'cvv': '737',
        'vencimento': '03/30'
      }
      getBandeira( cartao )
    }

    setState( {
      ...state,
      [ name ]: valor
    } )
  }

  const handleBlur = event => {
    const { name } = event.target

    if ( camposObrigatorios.includes( name ) ) {
      validate( event )
    }
  }

  const handleSubmit = event => {
    event.preventDefault()
    validate( event, true )
    if ( onConfirmar && !isEmptyObject( cartaoValidado ) ) {
      onConfirmar( cartaoValidado )
    }
  }

  function renderRecaptcha() {
    const { grecaptcha } = window
    grecaptcha.enterprise.render( 'divCaptcha', {
      'sitekey': `${RECAPTCHA_KEY}`,
      'callback': callbackRecaptcha,
    } )
  }

  function callbackRecaptcha( captchaToken ) {
    setCaptcha( captchaToken )
  }

  return (
    <CartaoCreditoWrapper>
      {loading ?
        <LoadingWrapper>
          <InlineLoader
            cor={ tema }
            isCenter
          />
        </LoadingWrapper> : null}

      <ul className="lista--bandeira__cartao">
        {bandeiraCartao ? (
          <li>
            <img
              alt={ BANDEIRAS_IMAGES[ bandeiraCartao ] }
              src={ BANDEIRAS_IMAGES[ bandeiraCartao ] }
            />
          </li>
        ) : (
          Object.values( BANDEIRAS_IMAGES )
            .map( bandeira => (
              <li key={ bandeira }>
                <img
                  alt={ bandeira }
                  src={ bandeira }
                />
              </li>
            ) )
        )}
      </ul>

      <form onSubmit={ handleSubmit }>
        <div className="row--input">
          <Input
            erro={ erros.numero }
            label="Número do cartão"
            name="numero"
            onBlur={ handleBlur }
            onChange={ handleChange }
            onKeyPress={ handleKeyPress }
            onPressEnter={ handleSubmit }
            sucesso={ sucesso.numero }
            tipo={ Input.TIPO_TEL }
            value={ state.numero }
          />
        </div>

        <div className="row--input">
          <Input
            erro={ erros.nome }
            label="Nome do titular do cartão"
            name="nome"
            onBlur={ handleBlur }
            onChange={ handleChange }
            onPressEnter={ handleSubmit }
            sucesso={ sucesso.nome }
            value={ state.nome }
          />
        </div>

        <div className="row--input row--double">
          <Input
            column={ 2.1 }
            erro={ erros.vencimento }
            label="Vencimento"
            maxLength={ 5 }
            name="vencimento"
            onBlur={ handleBlur }
            onChange={ handleChange }
            onKeyPress={ handleKeyPress }
            onPressEnter={ handleSubmit }
            sucesso={ sucesso.vencimento }
            tipo={ Input.TIPO_TEL }
            value={ state.vencimento }
          />

          <div className="input--margin-cvv">
            <Input
              ascolumn={ 2.1 }
              erro={ erros.cvv }
              label="CVV"
              name="cvv"
              onBlur={ handleBlur }
              onChange={ handleChange }
              onKeyPress={ handleKeyPress }
              onPressEnter={ handleSubmit }
              sucesso={ sucesso.cvv }
              tipo={ Input.TIPO_TEL }
              tooltip={ TEXTO_HELPER_CVV }
              value={ state.cvv }
            />
          </div>
        </div>

        <CaptchaContainer>
          <div
            className="g-recaptcha"
            data-action="CHECKOUT"
            data-sitekey={ RECAPTCHA_KEY }
            id="divCaptcha"
          />
        </CaptchaContainer>

        {onCancelar && onConfirmar ?
          <BotaoWrapper>
            <Button
              className="button__cancelar"
              invertido
              onClick={ onCancelar }
              tema={ Button.BOTAO_CURADORIA }
            >
              Cancelar
            </Button>

            <Button
              disabled={ !camposObrigatoriosPreenchidos || captcha === null }
              tema={ Button.BOTAO_CURADORIA }
              type={ Button.TYPE_SUBMIT }
            >
              Confirmar
            </Button>
          </BotaoWrapper> : null}
      </form>
    </CartaoCreditoWrapper>
  )
}

CartaoCreditoForm.propTypes = {
  'errosCartao': object,
  'loading': bool,
  'onCancelar': func,
  'onConfirmar': func,
  'tema': string
}

CartaoCreditoForm.defaultProps = {
  'errosCartao': {},
  'loading': false,
  'onCancelar': null,
  'onConfirmar': null,
  'tema': StyleGuide.cores.azul
}

export default CartaoCreditoForm

